import { useEffect, useState } from "react";
import Header from "../../Components/SDE24/Header";
import HeaderO from "../../Components/SDO24/Header";
import * as api from '../../../api';
import EditParticipationB from "./EditParticipationB";
import EditParticipationA from "./EditParticipationA";
import EditParticipationBO from "../SDO2024/EditParticipationB";
import EditParticipationAO from "../SDO2024/EditParticipationA";
import Section from "../../Atoms/Section";
import BlueButton from "../../Atoms/BlueButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";


const EditParticipation = (props) => {

    const [participation, setParticipation] = useState(null);
    const [userId, setUserId] = useState(null);
    const [eventId, setEventId] = useState(null);
    const { i18n } = useTranslation('common');
    const navigate = useNavigate();

    //get event and user id from params
    useEffect(() => {
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
        const userIdFromParam = new URLSearchParams(window.location.search).get("uid");
        setUserId(userIdFromParam);
        setEventId(eventIdFromParam);
        if (!eventIdFromParam || !userIdFromParam) {
            console.log("no event id or user id in url");
            return;
        }
        api.getUserParticipations({userid: userIdFromParam}).then((resParticipations) => {
            const matchingParticipation = resParticipations.data.find(participation => participation.eventId === eventIdFromParam);
            if(matchingParticipation) {
                // console.log("matchingParticipation found :")
                // console.log(matchingParticipation)
                setParticipation(matchingParticipation);
            }
        })
    }, [])

    function deleteParticipation() {
        if (window.confirm(i18n.language === "fr" ? "Êtes-vous sûr de vouloir supprimer la participation ?" : "Are you sure you want to delete the participation ?")) {
            api.deleteParticipation(userId,eventId).then((response) => {
                // console.log(response);
                alert(i18n.language === "fr" ? "Participation supprimée" : "Participation deleted");
                navigate("/");
            }).catch((error) => {
                console.log(error);
            });
        }
    }

    return (<>
        {participation && participation.type[2] === "e" && <Header/>}
        {participation && participation.type[2] === "o" && <HeaderO/>}
        {participation && participation.type === "sdeb" && <>
            <EditParticipationB fullUser={props.fullUser}/>
        </>}
        {participation && participation.type === "sdea" && <>
            <EditParticipationA fullUser={props.fullUser}/>
        </>}
        {participation && participation.type === "sdob" && <>
            <EditParticipationBO fullUser={props.fullUser}/>
        </>}
        {participation && participation.type === "sdoa" && <>
            <EditParticipationAO fullUser={props.fullUser}/>
        </>}
        <Section className="padding">
            <BlueButton className="centered" style={{backgroundColor: "red"}} onClick={deleteParticipation}>{i18n.language === "fr" ? "Supprimer la participation" : "Delete participation"}</BlueButton>
        </Section>
    </>)
}

export default EditParticipation;
